<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="claimTypes"
    item-value="id"
    item-text="name"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ClaimTypeField",
  props: {
    value: Object,
    status: { type: String, required: false }
  },
  data: () => ({
    claimTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.post("/api/claimTypes/search?size=100", { isEffective: this.status }).then(({ data }) => {
      this.claimTypes = data.content;
    });
  }
};
</script>
